import { Button, Stack } from '@mui/material';

import { getGeneralFeedbackUrl } from 'constants/feedback.constants';
import { Routes } from 'constants/routes.constants';
import { useLocale } from 'hooks/useLocale';
import { useModalControl } from 'hooks/useModalControl';

import SettingsLink from 'components/@account/SettingsLink';
import ContactDialog from 'components/@common/ContactDialog';
import LinkUnstyled from 'components/@common/LinkUnstyled';

const SettingLinksList = () => {
  const { locale: activeLocale } = useLocale();
  const {
    open: openContact,
    onClose: onCloseContact,
    onOpen: onOpenContact,
  } = useModalControl();

  return (
    <Stack
      sx={{
        gap: 1,
        mb: 4,
      }}
    >
      <SettingsLink
        iconName="QuestionCircle"
        intlId="account.settings.help"
        component={Button}
        onClick={onOpenContact}
      />
      <SettingsLink
        iconName="Bulb"
        intlId="account.settings.feedback"
        component={LinkUnstyled}
        href={getGeneralFeedbackUrl(activeLocale)}
        target="_blank"
      />
      <SettingsLink
        iconName="List"
        intlId="account.settings.terms.of.use"
        component={LinkUnstyled}
        href={Routes.TermsOfService}
      />
      <SettingsLink
        iconName="Shield"
        intlId="account.settings.privacy"
        component={LinkUnstyled}
        href={Routes.PrivacyPolicy}
      />
      <ContactDialog open={openContact} onClose={onCloseContact} />
    </Stack>
  );
};

export default SettingLinksList;
